import Keycloak from 'keycloak-js';

export interface KeycloakConfig {
    clientId: string;
    url: string;
    realm: string;
}

let keycloakInstance: Keycloak | null = null;

export const initializeKeycloak = (config: KeycloakConfig): Keycloak => {
    if (!keycloakInstance) {
        keycloakInstance = new Keycloak(config);
    }
    return keycloakInstance;
};

export const getKeycloakInstance = (): Keycloak | null => {
    return keycloakInstance;
};

export default keycloakInstance;
